var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42857 0C5.87829 0 6.24286 0.349585 6.24286 0.780822V2.08219H12.7571V0.780822C12.7571 0.349585 13.1217 0 13.5714 0C14.0211 0 14.3857 0.349585 14.3857 0.780822V2.08219H15.7429C17.5418 2.08219 19 3.48054 19 5.20548V8.58904V15.8767C19 17.6017 17.5418 19 15.7429 19H3.25714C1.45828 19 0 17.6017 0 15.8767V8.58904V5.20548C0 3.48054 1.45828 2.08219 3.25714 2.08219H4.61429V0.780822C4.61429 0.349585 4.97886 0 5.42857 0ZM17.3714 8.58904H1.62857V15.8767C1.62857 16.7392 2.3577 17.4384 3.25714 17.4384H15.7429C16.6423 17.4384 17.3714 16.7392 17.3714 15.8767V8.58904ZM5.15714 9.89041C4.55752 9.89041 4.07143 10.3565 4.07143 10.9315C4.07143 11.5065 4.55752 11.9726 5.15714 11.9726H7.32857C7.92819 11.9726 8.41429 11.5065 8.41429 10.9315C8.41429 10.3565 7.92819 9.89041 7.32857 9.89041H5.15714Z",
    fill: "#3C4852"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.2a870fd75c321ed0d7174f465da2ed5d.svg";
export { ForwardRef as ReactComponent };